var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArtistIcon = function SvgArtistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.409 13.451a15.687 15.687 0 0 0-13.859 1.643c-3.666 2.251-6.074 7.845-5.282 11.861.939 4.752 5.619 7.742 11.935 6.008 6.81-1.869 8.458-5.868 8.237-6.886s-3.442-2.135-2.218-4.518c1.533-2.985 4.039-1.485 5.148-2.094s.69-4.447-3.96-6.013Zm-9.432 1.739a16.477 16.477 0 0 0-3.377 1.584 10.057 10.057 0 0 0-3.711 4.724.4.4 0 1 1-.736-.3 10.71 10.71 0 0 1 4.023-5.089 17.216 17.216 0 0 1 3.543-1.669.4.4 0 1 1 .251.752Zm4.724 12.085a1.947 1.947 0 1 1 1.35-2.376 1.943 1.943 0 0 1-1.35 2.376Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20893",
    fill: "none",
    d: "M0 0h46v46H0z"
  })));
};
export default SvgArtistIcon;